// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.special-trial-offer-modal-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  background: linear-gradient(90deg, #fff1e6 0%, #fde6f1 100%);
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  color: #c2255c;
}

.special-trial-offer-modal-badge img {
  display: block;
}

.special-trial-offer-modal .heading {
  font-size: 20px;
  font-weight: 700;
  color: #202223;
  margin: 4px 0 12px;
}

.special-trial-offer-modal .description p {
  margin: 0 0 4px;
  color: #202223;
}

.special-trial-offer-modal .checklist {
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
}

.special-trial-offer-modal .checklist li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
}

.special-trial-offer-modal .checklist li .Polaris-Icon {
  margin: 1px 0 0;
  flex-shrink: 0;
}

.special-trial-offer-modal .divider {
  border-top: 1px dashed #c9cccf;
  margin-top: 40px;
  border-bottom: 0;
}

/* Header/Footer are siblings of the body content, not ancestors — scope via :has() on their shared Dialog wrapper */
.Polaris-Modal-Dialog__Modal:has(.special-trial-offer-modal) .Polaris-Modal-Header {
  border-bottom: none;
  padding-bottom: 0;
}

.Polaris-Modal-Dialog__Modal:has(.special-trial-offer-modal) .Polaris-Modal-Footer {
  border-top: none;
  padding-top: 0;
}

.Polaris-Modal-Dialog__Modal:has(.special-trial-offer-modal) {
  background: linear-gradient(180deg, rgba(145, 233, 219, 0.1) 0%, rgba(140, 201, 234, 0.1) 100%),
    #ffffff;
}
`, "",{"version":3,"sources":["webpack://./src/styles/special-trial-offer-modal.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,4DAA4D;EAC5D,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oHAAoH;AACpH;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;WACS;AACX","sourcesContent":[".special-trial-offer-modal-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 4px 12px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, #fff1e6 0%, #fde6f1 100%);\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1;\n  color: #c2255c;\n}\n\n.special-trial-offer-modal-badge img {\n  display: block;\n}\n\n.special-trial-offer-modal .heading {\n  font-size: 20px;\n  font-weight: 700;\n  color: #202223;\n  margin: 4px 0 12px;\n}\n\n.special-trial-offer-modal .description p {\n  margin: 0 0 4px;\n  color: #202223;\n}\n\n.special-trial-offer-modal .checklist {\n  list-style: none;\n  margin: 16px 0 0;\n  padding: 0;\n}\n\n.special-trial-offer-modal .checklist li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.special-trial-offer-modal .checklist li .Polaris-Icon {\n  margin: 1px 0 0;\n  flex-shrink: 0;\n}\n\n.special-trial-offer-modal .divider {\n  border-top: 1px dashed #c9cccf;\n  margin-top: 40px;\n  border-bottom: 0;\n}\n\n/* Header/Footer are siblings of the body content, not ancestors — scope via :has() on their shared Dialog wrapper */\n.Polaris-Modal-Dialog__Modal:has(.special-trial-offer-modal) .Polaris-Modal-Header {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.special-trial-offer-modal) .Polaris-Modal-Footer {\n  border-top: none;\n  padding-top: 0;\n}\n\n.Polaris-Modal-Dialog__Modal:has(.special-trial-offer-modal) {\n  background: linear-gradient(180deg, rgba(145, 233, 219, 0.1) 0%, rgba(140, 201, 234, 0.1) 100%),\n    #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
